import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-application-list" }

import { ref, computed } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  useInputColumn,
  createDialog,
  BaseButton,
  XrkMessage,
  BaseIcon,
  BaseToolTip
} from 'xrk-components';

import { formatter } from '@/utils';
import {
  settlementPeopleList,
  settlementAudit,
  settlementSurvey
} from '../data-source/apis';
import { IN_STATUS, AUTH_STATUS } from '../constants/index';
import BaseInsert from '../components/base-insert.vue';
import { WarningFilled, ChatLineSquare } from '@element-plus/icons-vue';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'project-application-list',
  setup(__props) {

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);

const xrkTableRef = ref();
const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useInputColumn({
      prop: 'name',
      label: '姓名',
      config: {
        type: 'text',
        placeholder: '请输入',
        inputTextReplace: true,
        maxlength: 200
      }
    }),
    useInputColumn({
      prop: 'phone',
      label: '手机号',
      config: {
        type: 'tel',
        placeholder: '请输入'
      }
    }),
    useSelectColumn({
      prop: 'auditStatus',
      label: '审核状态',
      config: {
        placeholder: '请选择',
        options: AUTH_STATUS
      }
    }),
    useSelectColumn({
      prop: 'status',
      label: '申请内容',
      config: {
        placeholder: '请选择',
        options: IN_STATUS
      }
    })
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px'
    }),
    useTableColumn({
      label: '终端服务人员',
      prop: 'name',
      render({ row, cellValue }) {
        return (
          <>
            <div style="display: flex; align-items: center;">
              <span style="margin-right: 5px;">{cellValue}</span>
              {row.cancelStatus ? (
                <BaseToolTip
                  effect="dark"
                  content="已注销不可执行项目"
                  placement="top-start"
                >
                  <BaseIcon size="15" color="red">
                    <WarningFilled />
                  </BaseIcon>
                </BaseToolTip>
              ) : (
                ''
              )}
            </div>
          </>
        );
      }
    }),
    useTableColumn({
      label: '手机号',
      prop: 'phone'
    }),
    useTableColumn({
      label: '申请内容',
      prop: 'status',
      render({ cellValue, row }) {
        return (
          <>
            <div style="display: flex; align-items: center;">
              <span style="margin-right: 5px;">
                {IN_STATUS[cellValue]?.label || '-'}
              </span>
              {cellValue === 2 && (
                <BaseIcon
                  onClick={async () => {
                    const { data } = await settlementSurvey({
                      applyId: row.applyId
                    });
                    createDialog({
                      title: '申请内容',
                      confirmBtnConfig: {
                        show: false
                      },
                      cancelBtnConfig: {
                        show: true,
                        content: '关闭'
                      },
                      width: 800,
                      contentRender: () => {
                        return (
                          <>
                            <div style="padding:20px">
                              {data.map((item, index) => {
                                return (
                                  <div style="margin-bottom:10px;">
                                    <div>
                                      {`${index + 1}、${item.question}`}
                                    </div>
                                    <div>{`答案：${item.answer}`}</div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        );
                      }
                    });
                  }}
                  style="cursor:pointer;"
                  size="15"
                  color="var(--xrk-color-primary)"
                >
                  <ChatLineSquare />
                </BaseIcon>
              )}
            </div>
          </>
        );
      }
    }),
    useTableColumn({
      label: '申请时间',
      prop: 'createAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '审核状态',
      prop: 'authStatus',
      formatter({ cellValue }) {
        return AUTH_STATUS[cellValue]?.label;
      }
    }),
    useTableColumn({
      label: '审核时间',
      prop: 'authAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作',
      prop: 'handlerCol',
      fixed: 'right',
      render: ({ row }) => {
        return (
          <div>
            <BaseButton
              v-resource={[['审核']]}
              type="text"
              disabled={+row.authStatus !== 1}
              onClick={() => {
                createDialog({
                  width: 350,
                  title: '提示',
                  content: `是否确认通过，请谨慎操作`,
                  beforeConfirm: async done => {
                    await settlementAudit({
                      applyId: row.applyId,
                      auditStatus: 2
                    });
                    XrkMessage.success('操作成功');
                    done();
                    onRefreshTabel();
                  }
                });
              }}
            >
              通过
            </BaseButton>
            <BaseButton
              v-resource={[['审核']]}
              type="text"
              disabled={+row.authStatus !== 1}
              onClick={() => {
                const baseInsertRef = ref();
                createDialog({
                  title: '审核不通过',
                  width: 370,
                  contentRender: () => {
                    return (
                      <>
                        <BaseInsert
                          labelPosition={'left'}
                          ruleValidator={(
                            rule: any,
                            value: any,
                            callback: any
                          ) => {
                            if (value === '') {
                              return callback(
                                new Error('请填写不通过原因，最少5个字')
                              );
                            } else if (value.length < 5) {
                              return callback(
                                new Error('请填写不通过原因，最少5个字')
                              );
                            } else {
                              callback();
                            }
                          }}
                          label={''}
                          placeholder={'请填写不通过原因，最少5个字'}
                          maxlength={150}
                          type="textarea"
                          rows={8}
                          ref={baseInsertRef}
                        ></BaseInsert>
                      </>
                    );
                  },
                  async beforeConfirm(done) {
                    const { data } = await baseInsertRef.value.getFormData();
                    await settlementAudit({
                      auditStatus: 3,
                      auditRemark: data,
                      applyId: row.applyId
                    });
                    XrkMessage.success('操作成功');
                    done();
                    onRefreshTabel();
                  }
                });
              }}
            >
              不通过
            </BaseButton>
          </div>
        );
      }
    })
  ].filter(item => item)
});

const getListAjax = async params => {
  const data = await settlementPeopleList({
    ...params,
    projectId: projectInfo.value.id
  });
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})